export default __webpack_public_path__ + "static/2_16-b6ef9084dc707aa1737a72ccd374e55a.png";